<ng-container *transloco="let t">
  <div class="container">
    <ISpinner class="placeholder" [display]="loader()" />
    <div class="flex flex-col gap-4">
      @if (!loader() && metric().type === RATIO) {
        <div class="flex flex-1 flex-col items-center gap-1">
          <div class="text-gray-600">{{ t("traffic-stats-chart.filtered_traffic") }}</div>
          @if (barChartRows().length) {
            <IChart class="flex-1" [config]="filteredDataBarChartConfig()" [data]="barChartRows()" />
          } @else {
            <div class="mt-2 text-sm text-gray-500">{{ t("common.no_data") }}</div>
          }
        </div>
        <div class="flex flex-1 flex-col items-center gap-1">
          <div class="text-gray-600">{{ t("traffic-stats-chart.rest_of_traffic") }}</div>
          @if (restOfTrafficBarChartRows().length) {
            <IChart class="flex-1" [config]="restOfTrafficBarChartConfig()" [data]="restOfTrafficBarChartRows()" />
          } @else {
            <div class="mt-2 text-sm text-gray-500">{{ t("common.no_data") }}</div>
          }
        </div>
      }
      @if (!loader() && metric().type !== RATIO) {
        <IChart [config]="donutChartConfig()" [data]="data()" />
      }
    </div>
  </div>
</ng-container>
